module.exports = __webpack_public_path__ + "8ed87d99ea8af8e178d7d53b64641b45.png";


//////////////////
// WEBPACK FOOTER
// ./images/about_portrait.png
// module id = 295
// module chunks = 0